import React, { memo, useState, useCallback } from 'react'
import { CirclePlusMajor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { ContractorNoteModal } from './ContractorNoteModal'
import { colors } from 'src/theme'

interface Props {
  contractorId: string
  refreshContractorNotes(): void
}

const CreateContractorNoteButtonComponent = ({ contractorId, refreshContractorNotes }: Props) => {
  const [isContractorNoteModalOpen, setIsContractorNoteModalOpen] = useState(false)

  const openContractorNoteModal = useCallback(() => setIsContractorNoteModalOpen(true), [])
  const closeContractorNoteModal = useCallback(() => setIsContractorNoteModalOpen(false), [])

  return (
    <>
      <Button
        fullWidth
        color="light"
        size="small"
        onClick={openContractorNoteModal}
        endIcon={<CirclePlusMajor width={20} fill={colors.PRIMARY_PURPLE_500} />}
      >
        Add new note
      </Button>
      <ContractorNoteModal
        isContractorNoteModalOpen={isContractorNoteModalOpen}
        closeContractorNoteModal={closeContractorNoteModal}
        contractorId={contractorId}
        refreshContractorNotes={refreshContractorNotes}
      />
    </>
  )
}

export const CreateContractorNoteButton = memo(CreateContractorNoteButtonComponent)
